import { cx } from "@/utils";

import styles from "./Rhythm.module.css";

type RhythmProps = {
  children: React.ReactNode;
  className?: string;
  fullHeight?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const Rhythm: React.FC<RhythmProps> = ({
  children,
  className,
  fullHeight = false,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cx(
        styles.root,
        {
          [styles.fullHeight]: fullHeight,
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export default Rhythm;
